import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-stop-sharing',
  templateUrl: './stop-sharing-popup.component.html',
  styleUrls: ['./stop-sharing-popup.component.scss']
})
export class StopSharingPopupComponent implements OnInit {
  @Input() link: string;
  @Input() name: string;
  @Output() onConfirm = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  confirm(): void {
    this.onConfirm.emit();
  }
  cancel(): void {
    this.onCancel.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/stop-sharing-popup/stop-sharing-popup.component.ts